import { render, staticRenderFns } from "./CarroReadMotorista.vue?vue&type=template&id=e8598472&scoped=true&"
import script from "./CarroReadMotorista.vue?vue&type=script&lang=js&"
export * from "./CarroReadMotorista.vue?vue&type=script&lang=js&"
import style0 from "./CarroReadMotorista.vue?vue&type=style&index=0&id=e8598472&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8598472",
  null
  
)

export default component.exports